module.exports = __webpack_public_path__ + "static/05-cbe720190e94eae9a28ba2297cbdcefb.jpg";